<div class="field">
  <app-form-edit-field-label
    #label
    fieldName="Title"
    [(data)]="data.label"></app-form-edit-field-label>
  <div class="form-group mt-2">
    <label class="form-label" [for]="'description' + id">Description</label>
    <textarea
      class="form-control"
      type="text"
      [(ngModel)]="data.helperText"
      [id]="'description' + id"></textarea>
  </div>
</div>
